import type { FC } from 'react';
import { useMemo } from 'react';
import { Card, Stack, styled, Typography } from '@mui/material';
import type { LabelColor } from '@pflegenavi/web-components';
import { Label } from '@pflegenavi/web-components';
import { DirectDebitStatus } from '@pflegenavi/shared/api';
import { useTranslation } from 'react-i18next';

interface DirectDebitStatusCardProps {
  status: DirectDebitStatus;
}

export const DirectDebitStatusCard: FC<DirectDebitStatusCardProps> = ({
  status,
}) => {
  const { t } = useTranslation();

  const labelColor: LabelColor = useMemo(() => {
    if (status === DirectDebitStatus.Active) {
      return 'success';
    }
    if (status === DirectDebitStatus.Pending) {
      return 'warning';
    }
    return 'error';
  }, [status]);

  return (
    <RootContainer>
      <InnerContainer direction="row" alignItems="center" spacing={2}>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          {t('nursing-home.current-direct-debit-status')}
        </Typography>
        <Label
          variant="filled"
          color={labelColor}
          sx={{
            color:
              status === DirectDebitStatus.Pending ? 'primary.main' : 'white',
          }}
        >
          {t(renderDirectDebitStatus(status))}
        </Label>
      </InnerContainer>
    </RootContainer>
  );
};

const renderDirectDebitStatus = (directDebit: DirectDebitStatus): string => {
  const directDebitString = directDebit.toLowerCase();
  return `direct-debit.status.${directDebitString}`;
};

const RootContainer = styled(Card)(({ theme }) =>
  theme.unstable_sx({
    p: 1,
    width: '100%',
    borderRadius: 3,
    mb: 2,
  })
);

const InnerContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    bgcolor: 'grey.200',
    paddingX: 2,
    paddingY: 3,
    borderRadius: 3,
  })
);
